import { isTMA } from '@tma.js/sdk'
import type { PlatformAdapter } from './adapter'
import { MaxPlatformAdapter } from './max.adapter'
import { MockPlatformAdapter } from './mock.adapter'
import { TelegramPlatformAdapter } from './telegram.adapter'

export * from './adapter'
export { MaxPlatformAdapter, MockPlatformAdapter, TelegramPlatformAdapter }

export function detectPlatformAdapter(): PlatformAdapter {
  if (typeof window === 'undefined') return new MockPlatformAdapter()
  // Telegram: the bundled @tma.js SDK can recognise the TMA environment by
  // inspecting URL hash + sessionStorage for launch params. Crucially, this
  // does NOT depend on `telegram.org/js/telegram-web-app.js` having loaded —
  // the native TG client injects everything we need into the WebView.
  if (isTMA()) return new TelegramPlatformAdapter()
  if (window.WebApp?.initData) return new MaxPlatformAdapter()
  return new MockPlatformAdapter()
}
